export function toggleNumberedList(selectedText) {
    if (!selectedText) return '';

    const lines = selectedText.split('\n');

    const allNumbered = lines.every((line, i) => line.trim().startsWith(`${i + 1}. `));

    if (allNumbered) {
        // Remove numbering
        return lines.map(line =>
            line.replace(/^\s*\d+\.\s*/, '')
        ).join('\n');
    } else {
        // Add numbering
        return lines.map((line, i) =>
            line.trim() === '' ? '' : `${i + 1}. ${line}`
        ).join('\n');
    }
}
